export const REFUND_MODE_OPTIONS = [
    { text: "Original Payment", value: "ORIGINAL" },
    { text: "Wallet", value: "WALLET" },
];

export const RETURN_POLICY_TABLE_FIELDS = [
    { key: "refundMode", label: "Refund Mode" },
    { key: "createdAt", label: "Created Date" },
    { key: "allowCancellation", label: "Allow Cancellation" },
    {
        key: "returnWindowDays",
        label: "Return/Replacement Window(in Days)",
        class: "text-center",
    },
    {
        key: "action",
        label: "Action",
        class: "text-center",
        thStyle: { width: "8%" },
    },
];

export const FILTER_INCLUDED_FIELDS = ["refundMode", "returnWindowDays"];
